__turbopack_context__.v({
  "cellContent": "TaxYearlyReportListBody-module-scss-module__wh7Sgq__cellContent",
  "mobileOrgInfo": "TaxYearlyReportListBody-module-scss-module__wh7Sgq__mobileOrgInfo",
  "nonDeductibleDonationsTable": "TaxYearlyReportListBody-module-scss-module__wh7Sgq__nonDeductibleDonationsTable",
  "nonDeductibleInfo": "TaxYearlyReportListBody-module-scss-module__wh7Sgq__nonDeductibleInfo",
  "summaryTable": "TaxYearlyReportListBody-module-scss-module__wh7Sgq__summaryTable",
});
